import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayBlockClickedPayload {
  shiftId: string;
  professionalId?: string;
}

/**
 * Fires when an office clicks "Block Professional" within the end-of-day flow.
 * Event: dental_portal:end_of_day:block_clicked
 */
export function fireEndOfDayBlockClicked(payload: IEndOfDayBlockClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:block_clicked', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
  });
}
